import { render } from "./KpiCalendarDetail.vue?vue&type=template&id=8070c16a&scoped=true"
import script from "./KpiCalendarDetail.vue?vue&type=script&lang=js"
export * from "./KpiCalendarDetail.vue?vue&type=script&lang=js"

import "./KpiCalendarDetail.vue?vue&type=style&index=0&id=8070c16a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8070c16a"],['__file',"src/views/qywx/crm/kpi/KpiCalendarDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8070c16a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8070c16a', __exports__)) {
    api.reload('8070c16a', __exports__)
  }
  
  module.hot.accept("./KpiCalendarDetail.vue?vue&type=template&id=8070c16a&scoped=true", () => {
    api.rerender('8070c16a', render)
  })

}


export default __exports__